import moment from "moment";

export function depositHoldDate(hold) {
  const value = hold && (hold.retain_until || hold.renew_due_at);
  return value && moment(value).isValid() ? moment(value).format("DD.MM.YYYY") : "—";
}

export function depositHoldUnbindText(vm, hold, fallbackKey) {
  if (!hold) return vm.$t(fallbackKey);
  return vm.$t("tinkoff.unbind_with_hold_text", {
    sum: Number(hold.amount) || 0,
    date: depositHoldDate(hold),
  });
}
